/**
 * @file authService.js
 * @description Authentication service to handle login, signup, and user management API calls.
 */

import api from "./apiClient";

const API_BASE_URL = "https://utility.wiiz.it/api/super-admin";

/**
 * Helper to handle API responses
 */
async function handleResponse(response) {
    const text = await response.text();
    let data;
    try {
        data = text ? JSON.parse(text) : {};
    } catch (e) {
        data = {};
        console.error("Failed to parse JSON response", e);
    }

    if (!response.ok) {
        const error = (data && (data.message || data.error)) || response.statusText;
        throw new Error(error);
    }
    return data;
}



export const authService = {
    /**
     * Login user
     * @param {string} username 
     * @param {string} password 
     */
    login: async (username, password) => {
        const response = await fetch(`${API_BASE_URL}/login`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ username, password })
        });
        const data = await handleResponse(response);
        // API returns data structure. Let's assume standard response or check previous logs.
        // Curl example response isn't shown, but we can infer it likely has the token.
        return data;
    },

    /**
     * Signup a new user (Self-registration if applicable)
     * POST /api/super-admin/users/create
     */
    signup: async (userData) => {
        const response = await api.post(`${API_BASE_URL}/users/create`, userData);
        return response.data;
    },

    /**
     * Create a new user (Admin function)
     * POST /api/super-admin/users/create
     */
    createUser: async (userData) => {
        const response = await api.post(`${API_BASE_URL}/users/create`, userData);
        return response.data;
    },

    /**
     * List all users
     * GET /api/super-admin/users/list
     */
    listUsers: async () => {
        const response = await api.get(`${API_BASE_URL}/users/list`);
        return response.data;
    },

    /**
     * Delete a user
     * DELETE /api/super-admin/users/delete
     */
    deleteUser: async (username) => {
        const response = await api.delete(`${API_BASE_URL}/users/delete`, {
            data: { username }
        });
        return response.data;
    }
};
